import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, Grid, Typography, Box } from "@mui/material";
import CurrencySelector from "./CurrencySelector";
import CloseIcon from "./CloseIcon";
import PaymentPlans from "./PaymentPlans";
import FeatureTable from "./FeatureTable";
import PremiumFeatures from "./PremiumFeatures";

const PaymentButton = ({ open, handleClose }) => {
  const [currency, setCurrency] = useState("INR");

  useEffect(() => {
    if (open) {
      localStorage.setItem("isPremium", false);
    }
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      {/* Close button */}
      <Box
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          zIndex: 10,
          cursor: "pointer",
        }}
      >
        <CloseIcon />
      </Box>

      {/* Header: Title + Currency Selector */}
      <Box
        sx={{
          p: 3,
          marginRight: 5,
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography
          variant="h4"
          color="secondary"
        >
          Choose Your Premium Plan
        </Typography>

        <CurrencySelector currency={currency} setCurrency={setCurrency} />
      </Box>

      {/* Dialog content below */}
      <DialogContent>
        <Grid container spacing={3}>
          <PaymentPlans currency={currency} />
        </Grid>

        <FeatureTable />
        <PremiumFeatures />
      </DialogContent>
    </Dialog>
  );
};

export default PaymentButton;
